var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBooking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.4997 50L45.833 58.3333L64.583 39.5833M30.557 15.9112C33.9063 15.644 37.086 14.3269 39.6433 12.1476C45.611 7.06192 54.3883 7.06192 60.3561 12.1476C62.9134 14.3269 66.093 15.644 69.4423 15.9112C77.2582 16.5349 83.4647 22.7414 84.0884 30.5574C84.3557 33.9067 85.6728 37.0863 87.8521 39.6436C92.9378 45.6113 92.9378 54.3886 87.8521 60.3564C85.6728 62.9137 84.3557 66.0933 84.0884 69.4426C83.4647 77.2586 77.2582 83.465 69.4423 84.0888C66.093 84.356 62.9134 85.6731 60.3561 87.8524C54.3883 92.9381 45.611 92.9381 39.6433 87.8524C37.086 85.6731 33.9063 84.356 30.557 84.0888C22.7411 83.465 16.5346 77.2586 15.9109 69.4426C15.6436 66.0933 14.3266 62.9137 12.1473 60.3564C7.06159 54.3886 7.06159 45.6113 12.1473 39.6436C14.3266 37.0863 15.6436 33.9067 15.9109 30.5574C16.5346 22.7414 22.7411 16.5349 30.557 15.9112Z",
    stroke: "#4D7DB4",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooking);
export default __webpack_public_path__ + "static/media/booking.21911ccea88cf7f4cfc0e800634083b4.svg";
export { ForwardRef as ReactComponent };